<template>
  <div></div>
</template>
  
<script>
import { apiGetUserLogin_sh, apiGetOpenId } from '@/api/insurance';
import * as types from '@/store/mutation-types.js';
import { isiOS } from '@/utils/bridge.js';
import { Toast } from 'vant'
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export default {
  data() {
    return {
      WXcode: '',
    };
  },
  methods: {
    async getWXCode() {
      if (isWechat()) {
        // wx84a082d6e1aaaa1a
        let appid = localStorage.getItem('weChatOfficialAccountType') == '2' ? 'wxf91f646263070b5f' : 'wx6291bd6ded26851f'
        let WXcode = this.getUrlCode().code; //是否存在code
        let local = window.location.href;
        // let local = 'https://mp.sit.beyonds.com';
        if (WXcode == null || WXcode === '') {
          //不存在就打开上面的地址进行授权
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
            local
          )}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
        } else {
          this.WXcode = WXcode;
          let openId = await apiGetOpenId(this.WXcode);
          if (openId) {
            localStorage.setItem('openid', openId);
          }
          openId = localStorage.getItem('openid');
          let data = {
            openId,
            deviceType: isiOS ? 1 : 2,
            type: 5,
          };
          let res = await apiGetUserLogin_sh(data);

          if (res.status != 200) {
            Toast(res.message);
            return
          }
          if (res.data?.token) {
            this.$store.commit('account/ACCOUNT_TOKEN', res.data?.token);
            // 已绑定
            window.location.replace(`${location.origin}${location.pathname}#/outInList?userId=${res.data.userId}`)
          } else {
            let appid = localStorage.getItem('weChatOfficialAccountType') == '2' ? 'wxf91f646263070b5f' : 'wx6291bd6ded26851f'
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${location.origin}/api/phoenix/phoenix/arctic/v1/wx/callBackForCheckUser&response_type=code&scope=snsapi_base&#wechat_redire`
          }

        }
      }
    },
    getUrlCode() {
      // 截取url中的code方法
      let url = location.search;
      let theRequest = new Object();
      if (url.indexOf('?') != -1) {
        var str = url.substr(1);
        var strs = str.split('&');
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }
      return theRequest;
    },
  },
  mounted() {
    this.getWXCode();
  },
};
</script>
  